import { NgModule } from '@angular/core';
import { HasPermissionDirective } from './user-has-permissions.directive';
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
@NgModule({
    declarations: [
        HasPermissionDirective,
    ],
    exports: [
        HasPermissionDirective,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
    ]
})
export class HasPermissionModule { }